import { Link } from 'react-router-dom';
import { FaFilePdf, FaArrowRight } from 'react-icons/fa';
import SectionTitle from '../components/ui/SectionTitle';
import Button from '../components/ui/Button';
import Reveal from '../components/ui/Reveal';
import { CATALOGS } from '../data/catalogs';
import './CatalogsPage.css';

const GROUPS = [
  { label: 'Complete Range', filter: c => c.featured },
  { label: 'General Surgery', filter: c => c.id === 'general-surgery' },
  { label: 'Dental', filter: c => c.id === 'dental' },
  { label: 'Orthopedic', filter: c => c.productCategories?.includes('Orthopedic') },
];

export default function CatalogsPage() {
  return (
    <main className="catalogs-page">
      <section className="catalogs-page__hero">
        <div className="container">
          <SectionTitle
            title="Product Catalogs"
            subtitle="Browse and download our complete product catalogs — factory-direct from Sialkot, Pakistan"
            light
          />
        </div>
      </section>

      <section className="catalogs-page__body">
        <div className="container">
          {GROUPS.map(group => {
            const items = CATALOGS.filter(group.filter);
            if (!items.length) return null;

            return (
              <Reveal key={group.label} className="catalogs-page__group">
                <h3 className="catalogs-page__group-title">{group.label}</h3>
                <div className="catalogs-page__grid">
                  {items.map(catalog => (
                    <article key={catalog.id} className="catalog-card">
                      <div className="catalog-card__icon">
                        <FaFilePdf aria-hidden="true" />
                      </div>
                      <span className="catalog-card__cat">{catalog.category}</span>
                      <h4 className="catalog-card__title">{catalog.title}</h4>
                      <p className="catalog-card__desc">{catalog.description}</p>
                      <div className="catalog-card__meta">
                        <span>{catalog.pages} pages</span>
                        <span>{catalog.size}</span>
                      </div>
                      <div className="catalog-card__actions">
                        <Link to={catalog.route} className="catalog-card__view">
                          View Catalog <FaArrowRight aria-hidden="true" />
                        </Link>
                        <a
                          href={catalog.file}
                          download
                          className="catalog-card__download"
                        >
                          Download PDF
                        </a>
                      </div>
                    </article>
                  ))}
                </div>
              </Reveal>
            );
          })}

          <div className="catalogs-page__cta">
            <p>Need a custom instrument or bulk quotation? Our team responds within 24 hours.</p>
            <Button href="/#contact" variant="primary">Request a Quote</Button>
          </div>
        </div>
      </section>
    </main>
  );
}
